import { User, UserActions } from '../types/redux'
import { store } from './store'


export function signInAction(user: User): void {
	store.dispatch({
		type: UserActions.SIGN_IN,
		payload: user
	})
}

export function signOutAction(): void {
	store.dispatch({
		type: UserActions.SIGN_OUT,
		payload: void 0
	})
}

export function changeIsMFAEnabled(isMFAEnabled: boolean): void {
	store.dispatch({
		type: UserActions.CHANGE_IS_MFA_ENABLED,
		payload: isMFAEnabled
	})
}
